import React from 'react';
import ModalShell from './ModalShell';

export default function ConfirmDialog({
  open,
  title,
  description,
  confirmLabel = 'Potwierdź',
  cancelLabel = 'Anuluj',
  confirmTone = 'primary',
  onConfirm,
  onCancel,
}) {
  if (!open) {
    return null;
  }

  return (
    <ModalShell title={title} onClose={onCancel} className="confirm-dialog" closeLabel="Zamknij potwierdzenie">
      <div className="modal-confirm-copy">
        <p>{description}</p>
      </div>
      <div className="modal-footer">
        <button type="button" className="btn-secondary" onClick={onCancel}>
          {cancelLabel}
        </button>
        <button
          type="button"
          className={confirmTone === 'danger' ? 'btn-danger' : 'btn-primary'}
          onClick={onConfirm}
        >
          {confirmLabel}
        </button>
      </div>
    </ModalShell>
  );
}